(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    /**
     * <dosing-guide-modal>
     * A custom element that IS the dialog. It owns its own open/close
     * state and reacts to two custom events dispatched on itself:
     *   - "dosing-guide:open"
     *   - "dosing-guide:close"
     * It also wires its own overlay + close ("x") button clicks and its
     * own Escape keydown — all scoped to this element, never to document.
     */
    class DosingGuideModal extends HTMLElement {
      connectedCallback() {
        // Overlay + close button(s) inside this modal instance.
        this.querySelectorAll('[data-close]').forEach((closeEl) => {
          closeEl.addEventListener('click', () => this.close());
        });

        // Custom event listeners actually flip the visible state.
        this.addEventListener('dosing-guide:open', () => this._show());
        this.addEventListener('dosing-guide:close', () => this._hide());

        // Escape closes this modal, but only while it's open, and the
        // listener lives on the element itself (not on document).
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }

      open() {
        this.dispatchEvent(new CustomEvent('dosing-guide:open', { bubbles: true }));
      }

      close() {
        this.dispatchEvent(new CustomEvent('dosing-guide:close', { bubbles: true }));
      }

      _show() {
        this.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        this.focus();
      }

      _hide() {
        this.removeAttribute('open');
        document.body.style.overflow = '';
      }
    }

    /**
     * <dosing-guide-block>
     * Wraps the trigger button + <dosing-guide-modal>. Its only job is
     * to connect a click on its own trigger button to modal.open().
     */
    class DosingGuideBlock extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('[data-open]');
        const modal = document.querySelector('dosing-guide-modal');

        if (trigger && modal) {
          trigger.addEventListener('click', () => modal.open());
        }
      }
    }

    if (!customElements.get('dosing-guide-modal')) {
      customElements.define('dosing-guide-modal', DosingGuideModal);
    }
    if (!customElements.get('dosing-guide-block')) {
      customElements.define('dosing-guide-block', DosingGuideBlock);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
